module.exports = __webpack_public_path__ + "img/sejarah.b94a5ab2.png";